import { initOembedContainers } from 'Shared/remote_embed';
import { bindLightboxImageClicks } from 'Shared/lightbox_image_clicks';

initOembedContainers();
// Story bodies render through the Answers post grammar, so their images
// carry the same data-lightbox-src markup.
bindLightboxImageClicks();

onDomReady(() => {
   $$('.js-add-image-modal').each(el => {
      el.addEvent('click', function (ev) {
         ev.stop();
         let imgUrl = this.get('data-modalImg');
         void import('Shared/modal').then(({ Modal }) => {
            Modal.openModalImg(imgUrl);
         });
      });
   });

   $$('.js-thumbnail-image').addEvent('mouseenter', ev => {
      let imageid = ev.target.get('data-imageid');
      $$('.js-main-image').hide();
      $('image-' + imageid).show();
   });
});
